import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiHome, FiChevronDown } from 'react-icons/fi';
import { TbGraph } from 'react-icons/tb';
import { FaRegEye } from 'react-icons/fa';
import { BsGlobe } from 'react-icons/bs';

import logo from '../images/logodatawhite.png';
import flybuy from '../images/logoflybye.png';

import '../css/general.css';
import '../css/styles.css';

const RPAInfo = () => {
  const location = useLocation();
  const basePath = location.pathname.startsWith('/uk') ? '/uk' : '';

  return (
    <div className="ad">
      <div className="sidebar">
        {/* Logo */}
        <Link to={`${basePath}/`}>
          <img src={logo} alt="DataScalp Logo" className="logo" />
        </Link>

        {/* Dashboard */}
        <div className="nav-item active">
          <div className="nav-item-header">
            <div className="nav-item-title">
              <FiHome size={18} />
              <span>Dashboard</span>
            </div>
            <FiChevronDown size={22} />
          </div>

          <div className="submenu">
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">One-Time Performance</div>
            </Link>
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">Cancellation</div>
            </Link>
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">Baggage Accuracy</div>
            </Link>
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">Time to Refund</div>
            </Link>
          </div>
        </div>

        {/* Rankings */}
        <div className="nav-item active">
          <div className="nav-item-header">
            <div className="nav-item-title">
              <TbGraph size={22} />
              <span>Rankings</span>
            </div>
            <FiChevronDown size={22} />
          </div>

          <div className="submenu">
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">Overall Rankings</div>
            </Link>
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">Regional Airlines</div>
            </Link>
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">Budget Airlines</div>
            </Link>
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">Premium Airlines</div>
            </Link>
          </div>
        </div>

        {/* Insights */}
        <div className="nav-item active">
          <div className="nav-item-header">
            <div className="nav-item-title">
              <FaRegEye size={18} />
              <span>Insights</span>
            </div>
            <FiChevronDown size={22} />
          </div>

          <div className="submenu">
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">Airport Rankings</div>
            </Link>
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">Delay Patterns</div>
            </Link>
            <Link to={`${basePath}/contact`} className="submenu-link">
              <div className="submenu-item">Airline Reviews</div>
            </Link>
          </div>
        </div>

        {/* Eco-Friendly */}
        <div className="nav-item eco-friendly">
          <Link to={`${basePath}/contact`} className="submenu-link">
            <div className="nav-item-title">
              <BsGlobe size={18} />
              <span>Eco-Friendly</span>
            </div>
          </Link>
        </div>

        {/* Flybuy Logo */}
        <img src={flybuy} alt="Flybuy Logo" className="flybuy-logo" />
      </div>

       <div className="rpa-info"></div>
    </div>
  );
};

export default RPAInfo;